export const errorCodes = {
  // FORBIDDEN_ERROR codes
  CSRF_TOKEN_MISMATCH: 'CSRF_TOKEN_MISMATCH',

  // More specific error code based on the error type,
  // So that client could handle it automatically.

  // Change pin error codes
  // 422 - UNPROCESSABLE_ENTITY
  UNSUPPORTED_CARD_TYPE: 'UNSUPPORTED_CARD_TYPE',
  STEPUP_AUTH: 'STEPUP_AUTH',
  DENIED_BY_RISK: 'DENIED_BY_RISK',
  DENIED: 'DENIED',
  RISK_STEPUPAUTH: 'RISK_STEPUPAUTH',
  INELIGIBLE: 'INELIGIBLE',
  NEED_MORE_DATA: 'NEED_MORE_DATA',
  MANUAL_REVIEW: 'MANUAL_REVIEW',
  UNEXPECTED_STATUS: 'UNEXPECTED_STATUS',
  UNSUPPORTED_OPERATION: 'UNSUPPORTED_OPERATION',
  INVALID_CARD_STATE: 'INVALID_CARD_STATE',

  // 403 - FORBIDDEN_ERROR
  // When feature is not enabled
  ACCESS_NOT_ALLOWED: 'ACCESS_NOT_ALLOWED',
  NOT_XHR_REQUEST: 'NOT_XHR_REQUEST',

  // Downstream API error codes
  UNKNOWN_STATUS_CODE: 'UNKNOWN_STATUS_CODE',
  FETCH_SPF_FLOW_ERROR: 'FETCH_SPF_FLOW_ERROR',
  FETCH_CARD_ERROR: 'FETCH_CARD_ERROR',
  FETCH_CARDS_ERROR: 'FETCH_CARDS_ERROR',
  FETCH_ADDRESS_ERROR: 'FETCH_ADDRESS_ERROR',
  FETCH_ADDRESSES_ERROR: 'FETCH_ADDRESSES_ERROR',
  FETCH_MORS_ERROR: 'FETCH_MORS_ERROR',
  FETCH_BALANCE_TRANSFER_SETTINGS_ERROR: 'FETCH_BALANCE_TRANSFER_SETTINGS_ERROR',
  APPLY_CARD_ERROR: 'APPLY_CARD_ERROR',
  CREATE_CARD_ERROR: 'CREATE_CARD_ERROR',
  ACTIVATE_CARD_ERROR: 'ACTIVATE_CARD_ERROR',
  REPORT_LOST_ERROR: 'REPORT_LOST_ERROR',
  GET_PIN_ERROR: 'GET_PIN_ERROR',
  FETCH_CARD_BASIC_TOUCHPOINT_ERROR: 'FETCH_CARD_BASIC_TOUCHPOINT_ERROR',
  GET_FUNDING_OPTIONS_ERROR: 'GET_FUNDING_OPTIONS_ERROR',
  GET_NOTIFICATION_PREFERENCES_ERROR: 'GET_NOTIFICATION_PREFERENCES_ERROR',
  UPDATE_NOTIFICATION_PREFERENCES_ERROR: 'UPDATE_NOTIFICATION_PREFERENCES_ERROR',
  LOYALTY_SUMMARY_ERROR: 'LOYALTY_SUMMARY_ERROR',

  // Common error codes
  UNSUPPORTED_PRODUCT_NAME: 'UNSUPPORTED_PRODUCT_NAME',

  // Validation error codes
  // 400 - Bad Request
  MISSING_RECOMMENDATION_CONTEXT: 'MISSING_RECOMMENDATION_CONTEXT',
  // walletsettingserv
  WALLET_SETTING_RISK_DECLINED: 'WALLET_SETTING_RISK_DECLINED',
} as const

export type ErrorCode = (typeof errorCodes)[keyof typeof errorCodes]
